import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-[#EEEDFE] dark:bg-[#26215C]/70", className)} {...props} />;
}

export { Skeleton };
